import MarkdownToJsx from 'markdown-to-jsx';

import Text from '@cartwhl/ui/base/Text';

import './LegalPageLayout.css';

export default function LegalPageLayout({ content }: { content: string }) {
  return (
    <div className="container py-16 lg:py-24">
      <div className="legal-content mx-auto max-w-3xl">
        <MarkdownToJsx
          options={{
            overrides: {
              h1: {
                component: Text,
                props: {
                  as: 'h1',
                  variant: 'web/display/2xl',
                  'lg:variant': 'web/display/3xl',
                  className: 'mb-8 lg:mb-12',
                },
              },
              h2: {
                component: Text,
                props: {
                  as: 'h2',
                  variant: 'web/display/lg',
                  'lg:variant': 'web/display/xl',
                  className: 'mb-4 mt-12 lg:mt-16',
                },
              },
              p: {
                component: Text,
                props: {
                  as: 'p',
                  variant: 'web/body/md',
                  className: 'text-secondary mb-4 leading-relaxed',
                },
              },
              strong: {
                component: 'strong',
                props: {
                  className: 'text-primary font-medium',
                },
              },
              a: {
                component: 'a',
                props: {
                  className:
                    'text-green-50 underline underline-offset-2 hover:text-green-35 transition-colors',
                  target: '_blank',
                  rel: 'noopener noreferrer',
                },
              },
              ul: {
                component: 'ul',
                props: {
                  className: 'mb-4 ml-6 list-disc space-y-2',
                },
              },
              li: {
                component: Text,
                props: {
                  as: 'li',
                  variant: 'web/body/md',
                  className: 'text-secondary leading-relaxed',
                },
              },
            },
          }}
        >
          {content}
        </MarkdownToJsx>
      </div>
    </div>
  );
}
